<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <h3 class="card-title">会員証発行</h3>
          </CCardHeader>
          <CCardBody>
            <CForm class="member-info edit-form">
              <CRow>
                <CCol class="px-0 pb-3">
                  <h4 class="sub-title">会員証ID情報</h4>
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6">
                  <!-- <CInput
                    label="新会員証ID"
                    class="required-mark"
                    horizontal
                    required
                    v-model="newCardId"
                  /> -->
                  <div class="required-mark form-group form-row">
                    <label class="col-form-label col-sm-3">新会員証ID</label>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        class="form-control"
                        v-model="ConvertId"
                      />
                    </div>
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="$v.newCardId.$dirty && !$v.newCardId.required"
                  >
                    新会員証IDの入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="$v.newCardId.$dirty && !$v.newCardId.numeric"
                  >
                    新会員証IDは数値を入力してください
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="$v.newCardId.$dirty && !$v.newCardId.maxLength"
                  >
                    新会員証IDは{{
                      valid.cardId.length
                    }}桁の数値を入力してください
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="$v.newCardId.$dirty && !$v.newCardId.minLength"
                  >
                    新会員証IDは{{
                      valid.cardId.length
                    }}桁の数値を入力してください
                  </div>
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <CInput
                    label="会員の氏名"
                    horizontal
                    plaintext
                    required
                    v-model="fullName"
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol class="px-0 pb-3 mt-4">
                  <span class="ml-4 text-warning"
                    >古い会員証ID {{ itemToEdit.cardId }} は廃止されます。</span
                  >
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>

          <CCardFooter>
            <div class="footer-navigation">
              <CButton
                @click="
                  $v.newCardId.$invalid ? requiredFd() : (confirmModal = true)
                "
                color="success"
                v-bind:class="$v.newCardId.$invalid ? 'inactive' : 'active'"
                class="ml-0 px-5"
                ><i class="icon cil-save"></i> 登録</CButton
              >
            </div>

            <!-- <CButton @click="goBack()" color="dark" class="ml-5 px-4">
              <b>←</b>戻る
            </CButton>-->
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

    <CButton
      @click="hasHistory() ? $router.go(-1) : $router.push('/')"
      class="my-5 btn btn-dark px-5"
    >
      <i class="icon cil-arrow-left"></i> 戻る
    </CButton>

    <CModal
      color="warning"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="confirmModal"
    >
      <!-- 更新してよろしいですか？ -->
      <CInput label="カードID" horizontal plaintext v-model="newCardId" />
      <CInput label="ユーザ名" horizontal plaintext v-model="fullName" />
      <span class="ml-3 text-warning"
        >古い会員証ID {{ itemToEdit.cardId }} は廃止されます。</span
      >
      <template #header> 発行確認 </template>
      <template #footer>
        <CButton
          @click="confirmModal = false"
          color="secondary"
          class="float-left"
          ><i class="icon cil-x"></i> 閉じる</CButton
        >
        <CButton @click="saveCardId()" color="success"
          ><i class="icon cil-send"></i> 発行</CButton
        >
      </template>
    </CModal>

    <CModal
      color="success"
      closeOnBackdrop
      :centered="true"
      :show.sync="completedModal"
    >
      <template #header>
        <h4>保存完了</h4>
      </template>
      保存が完了しました。
      <template #footer>
        <CButton
          @click="hasHistory() ? $router.go(-1) : $router.push('/')"
          color="success"
          ><i class="icon cil-x"></i> 閉じる</CButton
        >
      </template>
    </CModal>
         

  </div>
</template>

<script>
// import Vue from 'vue'
import axios from "axios";
import {
  required,
  numeric,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";

const CARD_ID = { LENGTH: 16 };

export default {
  components: {
    // FamilyMember
  },
  name: "MemberId",
  data() {
    return {
       
      confirmModal: false,
      addFamilyModal: false,
      editFamilyModal: false,
      deleteConfirmModal: false,
      deleteCompleteModal: false,
      completedModal: false,
      cardIdEditModal: false,
      gUserName: "",
      UserGroup: "",
      admin: false,
      relationId: "",
      fullName: "",

      currentItems: {},
      itemToEdit: {
        firstName: "",
        lastName: "",
        familyName: "",
        givenName: "",
        cardId: "",
      },
      newCardId: "",
      valid: {
        cardId: { length: CARD_ID.LENGTH },
      },
    };
  },
  created() {
    this.gUserName = this.$route.params.userId;
  },
  validations: {
    newCardId: {
      required,
      numeric,
      minLength: minLength(CARD_ID.LENGTH),
      maxLength: maxLength(CARD_ID.LENGTH),
    },
  },

  methods: {
    getUserInformation: function () {
      //Login as registered user
      var urlRequest = "/rest/users/" + this.gUserName;
      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.itemToEdit = resp.data;
          this.currentItems = this.itemToEdit;
          // this.currentCardId = this.itemToEdit.cardId;

          this.fullName =
            this.itemToEdit.familyName + " " + this.itemToEdit.givenName;
        })
        .catch((err) => {
             

          console.log(err);
        });
    },

    hasHistory() {
      return window.history.length > 2;
    },

    //#region    ===== function =====

    /**
     * カードID保存
     */
    saveCardId: function () {
      // const urlRequest = "/rest/users/" + this.gUserName;
      const urlRequest = "/rest/users/" + this.gUserName + "/card";
      console.log(this.currentItems);

      // NOTE: 会員情報編集前の値を使用して、カードIDのみ更新する
      // let body = this.currentItems;
      // body.cardId = this.newCardId;
      let newCardNo = {
        cardId: this.newCardId,
      };

      axios
        .put(urlRequest, newCardNo, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("Card Id saved:" + resp.data);
          this.getUserInformation();
          this.cardIdEditModal = false;
          this.completedModal = true;
          this.confirmModal = false;
        })
        .catch((err) => {
             

          console.log("Updating profile error: " + err);
          this.errors = err;
        });
    },

    /**
     * カードID編集ダイアログ
     */
    onCardIdEditClick() {
      this.newCardId = "";
      this.cardIdEditModal = true;
    },

    requiredFd() {
      this.$v.newCardId.$touch();
    },
  },
  beforeMount() {
    this.getUserInformation();
  },
  computed: {
    ConvertId: {
      get() {
        return this.newCardId;
      },
      set(value) {
        var conv = value.replace(/[\uff01-\uff5e]/g, function (ch) {
          return String.fromCharCode(ch.charCodeAt(0) - 0xfee0);
        });
        this.newCardId = conv;
      },
    },
  },
};
</script>